import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import AuthProvider from './components/AuthProvider';
import App from './App';
import './index.css';
import axios from 'axios';
import { installApiAuth } from './services/apiAuth';

// Sign-in token on /api/ calls made with the shared axios (moodleService)
installApiAuth(axios, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#1890ff',
              borderRadius: 6,
            },
          }}
        >
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);